import { ReactNode } from 'react';

import { ArrowLeftOutline, Button, VStack } from '@bonusly/design-system';

export interface BizySettingsSecondaryViewHeaderProps {
	backLabel: string;
	onBack: () => void;
}

interface BizySettingsSecondaryViewProps {
	children: ReactNode;
}

export const BizySettingsSecondaryViewHeader = ({ backLabel, onBack }: BizySettingsSecondaryViewHeaderProps) => (
	<Button leftIcon={<ArrowLeftOutline size="sm" />} onClick={onBack} size="sm" variant="ghost" colorScheme="secondary">
		{backLabel}
	</Button>
);

export const BizySettingsSecondaryView = ({ children }: BizySettingsSecondaryViewProps) => (
	<VStack align="stretch" spacing={6}>
		{children}
	</VStack>
);
